import { config } from '@/config/app.config';

export interface DefaultAssetProperties {
  exchange: string;
  ticker: string;
}

export interface FullAssetProperties extends DefaultAssetProperties {
  year: string;
  period: string;
}

const apiRoot = config.urls.apiRoot;

export const apiRoutes = {
  getSecurityUrl: (props: DefaultAssetProperties | FullAssetProperties) => {
    const { exchange, ticker, ...rest } = props;

    const defaultRoute = new URL(`/earnings/v1/${exchange}/${ticker}`, apiRoot);

    if ('year' in rest) {
      const { year, period } = rest;
      defaultRoute.searchParams.append('year', year);
      defaultRoute.searchParams.append('period', period.toUpperCase());
    }

    return defaultRoute.href;
  },
  searchUrl: new URL(`/earnings/v1/search`, apiRoot),
};
